import _Vue from "vue";
import Axios from "axios";

export function AxiosPlugin<AxiosPlugOptions>(Vue: typeof _Vue): void {
  Vue.prototype.$axios = Axios.create();
}
